import { css } from 'emotion';

export const title = css`
  margin-bottom: 20px;
`;

export const icon = css`
  margin-right: 10px;
`;

export const iconDesc = css`
  ${icon};
  transform: scale(1, -1);
`;

export const overlay = css`
  min-width: 150px;
  box-sizing: border-box;
  margin: 5px 0;
  padding: 20px;
`;

export const radioButton = css`
  && {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    &:last-of-type {
      margin: 0;
    }
  }
`;
